import consumer from "./consumer"

export default function createAiAssistantChatSubscription({threadId, onConnected, onDisconnected, onRejected, onReceived}) {
  let connected = false;

  const subscription = consumer.subscriptions.create(
    { channel: "AiAssistantChatChannel", thread_id: threadId },
    {
      received(data) {
        onReceived(data);
      },

      connected() {
        connected = true;
        onConnected();
      },

      disconnected() {
        connected = false;
        onDisconnected();
      },

      rejected() {
        connected = false;
        onRejected();
      },

      submitChat(chatData) {
        this.perform("submitChat", {message: chatData, thread_id: threadId});
      },

      isConnected() {
        return connected;
      },

      reconnect(callback) {
        // Unsubscribe and resubscribe logic
        this.unsubscribe();
        const newSub = createAiAssistantChatSubscription({threadId, onConnected, onDisconnected, onRejected, onReceived});
        if (callback) {
          // Wait a tick for connection to (re-)establish
          setTimeout(() => {
            if (newSub.isConnected()) callback();
          }, 500);
        }
        return newSub;
      }
    }
  );

  return subscription;
}
